import './App.css';
import {useTranslation} from "react-i18next";
import NavBar from "./components/navbar/NavBar";
import {Helmet} from "react-helmet-async";
import Main from "./components/main/Main";
import {Navigate, Route, Routes} from "react-router-dom";
import ProductPage from "./components/product/ProductPage";
import {eatSlowly, spendGently, fridgeOrganizer} from "./components/product/products";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import EatSlowlyPrivacy from "./components/privacy/eatSlowly/EatSlowlyPrivacy";
import SpendGentlyPrivacy from "./components/privacy/spendGently/SpendGentlyPrivacy";
import FridgeOrganizerPrivacy from "./components/privacy/fridgeOrganizer/FridgeOrganizerPrivacy";
import RunLordPrivacy from "./components/privacy/runLord/RunLordPrivacy";
import RedirectToStore from "./components/redirect/RedirectToStore";
import ScrollToTop from "./components/util/ScrollToTop";

const App = () => {
    const {t} = useTranslation();

    return (
        <div className="app-shell">
            <Helmet>
                <title>{t('site_title')}</title>
                <link rel="icon" href={'/favicon.svg'}/>
            </Helmet>
            <ScrollToTop/>
            <NavBar/>
            <main>
                <Routes>
                    <Route path="/" element={<Main />} />
                    <Route path="/eat-slowly" element={<ProductPage product={eatSlowly} />} />
                    <Route path="/spend-gently" element={<ProductPage product={spendGently} />} />
                    <Route path="/fridge-organizer" element={<ProductPage product={fridgeOrganizer} />} />
                    <Route path="/products" element={<Navigate to="/" replace />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/privacy/eatSlowly" element={<EatSlowlyPrivacy />} />
                    <Route path="/privacy/spendGently" element={<SpendGentlyPrivacy />} />
                    <Route path="/privacy/fridgeOrganizer" element={<FridgeOrganizerPrivacy />} />
                    <Route path="/privacy/runLord" element={<RunLordPrivacy />} />
                    <Route
                        path="/eat_slowly/download"
                        element={
                            <RedirectToStore
                                androidUrl="https://play.google.com/store/apps/details?id=com.persnormalsoft.eat_slowly"
                                iosUrl="https://apps.apple.com/us/app/eat-slowly/id6755353645"
                                webUrl="/eat-slowly"
                            />
                        }
                    />
                    <Route
                        path="/spend_gently/download"
                        element={
                            <RedirectToStore
                                androidUrl="https://play.google.com/store/apps/details?id=com.persnormalsoft.spend_gently"
                                iosUrl="https://apps.apple.com/app/spend-gently-mindful-budget/id6759556305"
                                webUrl="/spend-gently"
                            />
                        }
                    />
                    <Route
                        path="/fridge_organizer/download"
                        element={
                            <RedirectToStore
                                androidUrl={fridgeOrganizer.playStoreUrl}
                                iosUrl={fridgeOrganizer.appStoreUrl}
                                webUrl="/fridge-organizer"
                            />
                        }
                    />
                </Routes>
            </main>
            <Footer />
        </div>
    );
}
export default App;
